import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { IPurchaseRoFields, IDetailList } from './bmsBillPurchaseRoType';
import { purchaseRoService } from './bmsBillPurchaseRoService';
import { useBmsSaleRoDetailModel } from '../bmsBillSaleRo/bmsBillSaleRoModel';
export type IVrmRoDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	paidAmount: number;
	[key: string]: any;
};

export const useBmsPurchaseRoDetailsModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
		paidAmount: 0,
	};
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};

	const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IPurchaseRoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<IVrmRoDescType>(initDesc);

	//设置底部总数展示（查看|编辑|查看）
	useEffect(() => {
		let newDesc: IVrmRoDescType = { ...initDesc };
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.num) * Number(item.price);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await purchaseRoService.one(id);
		if (retData) {
			const { details, ...from } = retData;
			setDetailLookForm({
				...from,
				supplierTypeName: getBmsTreeNodeName(from.supplierTypeCode as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				payMethodName: getBmsTreeNodeName(from.payMethodName as string),
			});
			setDetailLookList((details as IDetailList[]) ?? []);
		}
	};

	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailLookList([]);
	};

	return {
		initPgCfg,
		detailLookForm,
		detailLookList,
		lookDesc,
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
